/**
 * Where a sound happens, in stereo (docs/proposals/ai-personas-voice-and-sound.md §Position):
 * "pan by where it happens — the board file for chess/checkers, seat for Bridge: North centre,
 * East right, West left, you centre".
 *
 * The value is a pan in [-1, 1]. Zero is centre and creates no panner node, so a centred sound
 * costs nothing. Seats and files are plain strings on purpose: the audio package does not depend
 * on the game engine, and every caller already has the name.
 */

/** The widest pan: the table's East and West seats, and the h- and a-files. */
export const PAN_MAX = 0.8;

/** The card table: North centre, East right, West left, South (the player) centre. */
export function seatPan(seat: string | null | undefined): number {
  if (seat === 'E') return PAN_MAX;
  if (seat === 'W') return -PAN_MAX;
  return 0;
}

/**
 * The board: the a-file is on the player's left, the h-file on the right.
 *
 * This assumes the board's fixed orientation — it does not rotate for the player's colour today
 * (the player is always White). If the board ever turns for Black, this mapping turns with it.
 */
export function filePan(file: string | null | undefined): number {
  if (!file) return 0;
  const idx = 'abcdefgh'.indexOf(file.trim().toLowerCase());
  if (idx < 0) return 0;
  return ((idx / 7) * 2 - 1) * PAN_MAX;
}
